/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Remuneration } from './remuneration';

export interface SearchInvoicePrepareDataVO {
    id?: string;
    automaticGenerationEnabled?: boolean;
    alertEmailRecipients?: string[];
    bccEmailRecipients?: string[];
    name?: string;
    description?: string;
    billingDirection?: SearchInvoicePrepareDataVO.BillingDirectionEnum;
    partnerCodes?: Array<string>;
    tenant?: string;
    rangeDateStart?: Date;
    rangeDateEnd?: Date;
    statusCommand?: string;
    statusCommands?: Array<string>;
    statusCommandsByProduct?: Record<string, string[]>;
    typeDate?: SearchInvoicePrepareDataVO.TypeDateEnum;
    typeTransaction?: 'command' | 'lead';
    product?: Array<string>;
    remunerations?: Array<Remuneration>;
    sendingblueTemplate?: number;
    invoiceTitle?: string;
    statementSuffix?: string;
    amountMode?: SearchInvoicePrepareDataVO.AmountModeEnum;
    billingFrequency?: SearchInvoicePrepareDataVO.BillingFrequencyEnum;
    invoiceGenerationDayOfMonth?: number;
}
export namespace SearchInvoicePrepareDataVO {
    export type BillingDirectionEnum = 'TENANT_TO_PROVIDER' | 'TENANT_TO_PARTNER';
    export const BillingDirectionEnum = {
        TENANTTOPROVIDER: 'TENANT_TO_PROVIDER' as BillingDirectionEnum,
        TENANTTOPARTNER: 'TENANT_TO_PARTNER' as BillingDirectionEnum
    };
    export type TypeDateEnum = 'RESERVATION_DATE' | 'TRAVEL_DATE';
    export const TypeDateEnum = {
        RESERVATIONDATE: 'RESERVATION_DATE' as TypeDateEnum,
        TRAVELDATE: 'TRAVEL_DATE' as TypeDateEnum
    };
    export type AmountModeEnum = 'VENTES' | 'PROFITS';
    export const AmountModeEnum = {
        VENTES: 'VENTES' as AmountModeEnum,
        PROFITS: 'PROFITS' as AmountModeEnum
    };
    export type BillingFrequencyEnum = 'M' | 'T';
    export const BillingFrequencyEnum = {
        M: 'M' as BillingFrequencyEnum,
        T: 'T' as BillingFrequencyEnum
    };
}
